import { computed, type ComputedRef, type Ref } from "vue";
import { useSharedState } from "composables/useSharedState";
import { useSlotPresence } from "composables/useSlotPresence";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import type { PlaceholderProps } from "./placeholder.types";
import { placeholderClasses } from "./placeholder.styles";

export interface UsePlaceholderOptions {
  props: Readonly<PlaceholderProps>;
}

export interface UsePlaceholderReturn {
  classes: ComputedRef<string>;
  hasContent: Ref<boolean>;
}

export const usePlaceholder = ({ props }: UsePlaceholderOptions): UsePlaceholderReturn => {
  useSharedState(props);

  const { default: hasContent } = useSlotPresence(["default"]);
  const classes = computed(() => mergeClassProp(placeholderClasses(), props.class));

  return { classes, hasContent };
};
